/**
 * Wrong-PIN throttling, per phone. 5 free tries, then a lockout that doubles each time
 * (30 s, 60 s, … capped at 15 min). Pure so it can be tested; persisted in meta.pin_attempts.
 */
export interface PinAttempts {
  failures: number
  locked_until: number
}

export const FREE_TRIES = 5
const BASE_LOCK_MS = 30_000
const MAX_LOCK_MS = 15 * 60_000

export const NO_ATTEMPTS: PinAttempts = { failures: 0, locked_until: 0 }

export function isLockedOut(a: PinAttempts, now: number): boolean {
  return a.locked_until > now
}

export function triesLeft(a: PinAttempts): number {
  // After a lockout ends the person gets a fresh set of tries.
  return FREE_TRIES - (a.failures % FREE_TRIES)
}

export function recordFailure(a: PinAttempts, now: number): PinAttempts {
  const failures = a.failures + 1
  if (failures % FREE_TRIES !== 0) return { failures, locked_until: a.locked_until }
  const rounds = failures / FREE_TRIES
  const lock = Math.min(MAX_LOCK_MS, BASE_LOCK_MS * 2 ** (rounds - 1))
  return { failures, locked_until: now + lock }
}

export function recordSuccess(): PinAttempts {
  return NO_ATTEMPTS
}
